import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

import 'font-awesome/css/font-awesome.css'

import ElementUI from 'element-ui'
if (process.env.NODE_ENV === 'development') {
    require('element-ui/lib/theme-default/index.css')
        // require('element-ui/lib/theme-chalk/index.css')
    require('bootstrap/dist/css/bootstrap.css')
    Vue.use(ElementUI)
}
require('swiper/dist/css/swiper.css')
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
// Vue.use(ElementUI)
import $ from "jquery"

//表单验证
import myValidate from "./tool/myValidate.js"
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN';
// Validator.addLocale(zh);
const config = {
    locale: 'zh_CN'
};
Vue.use(VeeValidate, config);
// 自定义validate
Validator.localize(myValidate.dictionary)
Validator.extend('idNum', myValidate.idNum);
Validator.extend('integer', myValidate.integer);
Validator.extend('nature', myValidate.nature);
Validator.extend('chinaMobile', myValidate.chinaMobile);
Validator.extend('numPat', myValidate.numPat);
Validator.extend('isDate', myValidate.isDate);
Validator.extend('dateMax', myValidate.dateMax);
Validator.extend('length', myValidate.length);

// 导入sentry
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// process.env.NODE_ENV === 'production' && Sentry.init({
//   dsn: 'http://941841ed47024b67913d47b5c5bac817@59.57.251.154:9121/4',
//   integrations: [new VueIntegration({Vue, attachProps: true})],
//   release: "test@1.0.1",
//   logErrors: true
// });

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})

// 包含
Vue.prototype.myInclude = function(list, value) {
    let isInclude = false;
    for (var i = 0; i < list.length; i++) {
        if (list[i] == value) {
            isInclude = true;
            break;
        }
    }
    return isInclude;
}

//拖动
$(document).on('mousedown', '.el-dialog__header', function(e) {
    let oBox = this.parentNode; //要移动的窗口
    let maxX = document.body.clientWidth - oBox.clientWidth;
    let maxY = document.body.clientHeight - 70;
    //要移动的窗口的位置
    let historyL = oBox.style.left;
    let historyT = oBox.style.top;
    if (historyT.toString().split('%').length > 1) {
        historyT = historyT.toString().split('%')[0] / 100 * document.body.clientHeight;
    }
    if (historyL == "") {
        historyL = oBox.offsetLeft;
    }
    // console.log('点击时 窗口位置: ' + historyL + ' || ' + historyT);
    // 按下鼠标时的鼠标位置
    let historyX = e.clientX;
    let historyY = e.clientY;
    document.onmousemove = function(e) {
        //通过事件委托，计算鼠标移动的距离
        let moveX = e.clientX - historyX;
        let moveY = e.clientY - historyY;
        // console.log('鼠标移动距离: ' + moveX + ' || ' + moveY);
        //移动元素
        let currentL = parseInt(historyL) + parseInt(moveX);
        let currentT = parseInt(historyT) + parseInt(moveY);
        // console.log('移动后 窗口位置: ' + currentL + ' || ' + currentT);
        // if (currentL < 0) {currentL = 0;}
        // else if (currentL > maxX) {currentL = maxX + 'px';}
        if (currentT < 0) { currentT = 0; } else if (currentT > maxY) { currentT = maxY + 'px'; }
        oBox.style.left = currentL + 'px';
        oBox.style.top = currentT + 'px';
    };
    document.onmouseup = function(e) {
        document.onmousemove = null;
        document.onmouseup = null;
    };
});



// WEBPACK FOOTER //
// ./src/main.js